export const categories = [
  "performance",
  "engagement",
  "culture",
  "wellbeing",

  // "leadership",
] as const

export const roles = ["user", "manager", "admin", "owner"] as const

export const activityTypes = [
  "anniversary",
  "coffee",
  "experience",
  "feedback",
  "onboarding",
  "other",
  "party",
  "people",
  "playbook",
  "pulse",
  "radio",
  "recognition",
  "reimbursement",
  "survey",
  "vacation",
] as const

export const shirtSizes = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"]

export const zodiacSigns = [
  "aries",
  "taurus",
  "gemini",
  "cancer",
  "leo",
  "virgo",
  "libra",
  "scorpio",
  "sagittarius",
  "capricorn",
  "aquarius",
  "pisces",
]
